import { ColDef } from "ag-grid-community";
import { k8sMonthlyPriceColumnDef } from "./common/k8sMonthlyPriceColumnDef";
import { k8sClusterColumnDef } from "./common/k8sClusterColumnDef";
import { k8sLabelsColumnDef } from "./common/k8sLabelsColumnDef";
import { k8sAgeColumnDef } from "./common/k8sAgeColumnDef";
import { k8sCpuRequestColumnDef } from "./common/k8sCpuRequestColumnDef";
import { getResourceSizeColumnDef } from "../common/getResourceSizeColumnDef";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { metricsHeaderCellTooltips } from "@/components/pages/common/resource-details/utils/constants/metricsHeaderCellTooltips";

export const k8sStatefulSetColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("StatefulSet Name"),

  k8sMonthlyPriceColumnDef,

  k8sClusterColumnDef,

  k8sAgeColumnDef,

  { field: "resource.namespace", headerName: "Namespace" },

  k8sCpuRequestColumnDef,

  getResourceMetricsColumnDef(
    "CPU Utilization Max",
    "cpu_percent",
    "kubernetes_stateful_set",
    metricsHeaderCellTooltips.get("kubernetes_stateful_set")?.cpu,
  ),

  getResourceMetricsColumnDef(
    "Memory Utilization Max",
    "memory_used_percent",
    "kubernetes_stateful_set",
    metricsHeaderCellTooltips.get("kubernetes_stateful_set")?.mem_used,
  ),

  getResourceSizeColumnDef({
    propName: "memory_request",
    headerName: "Memory Requests",
  }),

  { field: "resource.pod_count", headerName: "Pods" },

  k8sLabelsColumnDef,
];
